import { render } from "./StoryPieceEditor.vue?vue&type=template&id=5f8a5a50"
import script from "./StoryPieceEditor.vue?vue&type=script&lang=js"
export * from "./StoryPieceEditor.vue?vue&type=script&lang=js"

import "./StoryPieceEditor.vue?vue&type=style&index=0&id=5f8a5a50&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__